import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private http: HttpClient) {}
 
// apiUrl = 'https://test.testapi.ovh'; // Local development API
apiUrl = 'https://testapi.ovh'; // Production API

checkToken() {
  const token = localStorage.getItem('access_token');
//   console.log('[AuthService] Checking token:', token ? 'Token found' : 'No token found');
  // Always call the API, even if token is null/empty
  return this.http.get(`${this.apiUrl}/api/protected`, {
    headers: { Authorization: `Bearer ${token || ''}` }
  }).pipe(
    map(() => {
    //   console.log('[AuthService] Token is valid.');
      return true;
    }),
    catchError((err) => {
    //   console.error('[AuthService] Token check failed:', err);
      this.logoutAndRedirect();
      return of(false);
    })
  );
}

  logoutAndRedirect(): void {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('unit_id');
    window.location.href = '/login';
  }

  isLoggedIn(): boolean {
    const token = localStorage.getItem('access_token');
    return !!token;
  }
}